var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-row', {
    staticClass: "w-100 m-auto px-0"
  }, [_c('b-input-group', [_c('b-form-textarea', {
    staticClass: "spnod-text--thin mr-2",
    attrs: {
      "placeholder": "Type here...",
      "rows": "1",
      "disabled": !_vm.canSend
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('sendMessage')
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('scrollPage')
      }
    },
    model: {
      value: (_vm.model.messageBody),
      callback: function($$v) {
        _vm.$set(_vm.model, "messageBody", $$v)
      },
      expression: "model.messageBody"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticClass: "spnod-admin__form--button px-3",
    attrs: {
      "type": "submit",
      "value": "SEND",
      "disabled": !_vm.canSend
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('sendMessage')
      }
    }
  }, [_vm._v("\n        Send\n      ")])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2bac29e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Messaging/TextArea.vue
// module id = Cw3V
// module chunks = 2